import { cloneDeep, assign, pick } from "lodash";
import { get, post, del, put, easyHttp, download, downloadPost } from "@/assets/common/request";
import moment from "moment";
import {Juris} from "@/directives/Juris";
export default {
	data() {
		return {
			pagination: {
                sizes: [10, 20, 40, 50],
                layout: "total, sizes, prev, pager, next, jumper",
				page: 1,
				size: 10,
				total: 0,
			},
			query: {},
			tableLoading: false,
			tableData: [],
			selection: [],
			pickerOptions: {
				shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近一个月",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近三个月",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	methods: {
		handleSelectionChange(val) {
			this.selection = val;
		},
		handleSelectionCall(callback) {
			if (this.checkSelection()) {
				callback(this.getSelectionIds());
			}
		},
		checkSelection() {
			if (this.selection.length === 0) {
				this.$message({
					type: "info",
					message: "请选择至少一条数据",
				});
				return false;
			}
			return true;
		},
		getSelectionIds() {
			return this.selection.map((i) => i.id);
		},
		getSearchParams() {
			const params = cloneDeep(this.query);
			if (params.dataRange) {
				params.startDate = params.dataRange[0];
				params.endDate = params.dataRange[1];
				delete params.dataRange;
			}
			return params;
		},
		getList() {
            this._doQueryList(get);
		},
		getListPost() {
            this._doQueryList(post);
		},
        _doQueryList(request) {
            this.tableLoading = true;
			const searchParams = this.getSearchParams();
			const data = assign(searchParams, pick(this.pagination, ["page", "size"]));
			if (this.getListAfter) {
				this.getListBefore(data);
			}

			request.call(this, this.queryListUrl, data)
				.then((data) => {
					if (data && data.data) {
						// console.log(`查询接口：${this.queryListUrl}`, data.data.records || []);
						this.tableData = data.data.records;
						this.pagination.total = data.data.total;
						if (this.getListAfter) {
							this.getListAfter(data);
						}
					} else {
						console.error(`查询接口：${this.queryListUrl}异常`);
					}
				})
				.finally(() => {
                    this.tableLoading = false;
                });
        },
		_del(callback) {
			if (this.checkSelection()) {
				this.$confirm("将要删除选择的数据, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
                .then(() => {
                    callback(this.getSelectionIds());
                })
                .catch(() => {
                    // TODO 留空，只需catch即可，否则控制台会出错误信息
                });
			}
		},
		_export(title, url, params) {
            this._doExport(title, url, params, download);
		},
		_exportPost(title, url, params) {
            this._doExport(title, url, params, downloadPost);
		},
        _doExport(title, url, params, request) {
            
			return this.$confirm(`将要导出${title}, 是否继续?`, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "info",
			}).then(() => {
                const options = {
                    target: '.rightBody',
                    spinner: 'el-icon-printer',
                    text: '正在导出...'
                };
                let instance = this.$loading(options);
                return request.call(this, url, params || this.getSearchParams(), title)
                .finally(() => {
                    if(instance) {
                        instance.close();
                    }
                });
			}).catch(() => {
                // TODO 留空，只需catch即可，否则控制台会出错误信息
            });
        },
        _tip(desc, fn) {
            return this.$confirm(desc, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "info",
			}).then(() => {
                fn.call();
			}).catch(() => {
                // TODO 留空，只需catch即可，否则控制台会出错误信息
            });
        },
        _getDictLabel(dict, value) {
            if (dict && value) {
				const item = dict.find((e) => e.value == value);
				return item.label;
			}else {
                return '';
            }
        },
        isPermit(permitFlag) {
            if(permitFlag) {
                return Juris(permitFlag.toString());
            }
            return false;
        }
	},
    // 父组件中返回要传给下级的数据
    provide () {
        return {
            pagination: this.pagination,
            getList: this.getList
        }
    },
    filters: {
        dictLabel(value, dict) {
            if (dict && value) {
				const item = dict.find((e) => e.value == value);
				if(item) {
                    return item.label;
                }else {
                    return '';
                }
			}else {
                return '';
            }
        },
        toYuan(value) {
            let val = value;
            if(val) {
                if(!Number.isFinite(val)) {
                    val = Number.parseFloat(val);
                    if(Number.isNaN(val)) {
                        return value;
                    }
                }
                return round(divide(value, 100), 2);
            }else {
                return value;
            }
        },
        dateFmt(value, fmt) {
            if(value) {
                try {
                    return moment(value).format(fmt);
                }catch(e) {
                    console.error(e)
                    return "";
                }
            }else {
                "";
            }
        }
    },
    computed: {
        disableMulAction() {
            return this.selection == 0;
        }
    }
};
